import React from "react";
import style from './Dialogs.module.css';
import DialogItem from "./DialogItem/DialogItem";
import {Routes, Route} from "react-router-dom";
import Messages from "./Message/Messages";
// import Avatar from "./Avatar/Avatar";
import { ReactComponent as Icon } from "../../../Redux/icons/message.svg";

const Dialogs = (props) => {
    // let state = props.dialogsPage;
    // let myAvatar = props.dialogsPage.avatar;
    let dialogsArr = props.dialogsPage.dialogs.map(dialog => <DialogItem name={dialog.name} key={dialog.id} id={dialog.id} avatar={dialog.avatar}/>)
    let newMessageBody = props.dialogsPage.newMessageBody;
    let messagesArr = props.dialogsPage.dialogs.map(chat => <Route exact path={"user" + chat.id} element={<Messages key = {chat.id} id = {chat.id} messages={chat.messages} newMessageBody = {newMessageBody} updateNewMessageBody={props.updateNewMessageBody} sendMessage={props.sendMessage}/>}/>);

    return (
        <div className={style.dialogs}>
            <div className={style.dialogsBox}>
                {dialogsArr}
            </div>
            <div className={style.messagesBox}>
                <Routes>
                    <Route exact path="/dialogs/user1" element = {<Icon/>}/>}/>
                    {messagesArr}
                </Routes>
            </div>
        </div>
    )
}

export default Dialogs;